module.exports = __webpack_public_path__ + "real-estate.e7465a8366baf9d48deb.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/real-estate/webfont/real-estate.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/real-estate/webfont/real-estate.eot
// module chunks = styles